/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MeasurementUnit = "CM" | "IN" | "%future added value";
export type PdpRespHeroCarousel_user = {
    readonly profile: {
        readonly measurementUnit: MeasurementUnit | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarouselRequestMoreImages_user" | "PdpRespIconBubblesWrapper_user">;
    readonly " $refType": "PdpRespHeroCarousel_user";
};
export type PdpRespHeroCarousel_user$data = PdpRespHeroCarousel_user;
export type PdpRespHeroCarousel_user$key = {
    readonly " $data"?: PdpRespHeroCarousel_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarousel_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarousel_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "measurementUnit",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarouselRequestMoreImages_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubblesWrapper_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '0bbf9ca951bfaadf5ee91afff6c49603';
export default node;
